import _ from 'lodash'
import Vue from 'vue'
import { importComponent } from 'components/index'
import store from 'js/store'

let contentEl = null

export let instances = []


export let config = {
    contentSelector: '.content',
    componentAttribute: 'data-component',
    componentId: 'data-id'
}


export function initialize(mtwp) {
    _.defer(() => {
        if (mtwp.modules.pageLoader) {
            // destroy and remove components before content replacement
            mtwp.modules.pageLoader.config.hooks.beforeContentReplace.push(() => onBeforeContentReplace())
            // parse components after page loader content replacement
            mtwp.modules.pageLoader.config.hooks.afterContentReplace.push(() => parse())
        }
    })
}


export function ready(mtwp) {
    contentEl = document.querySelector(config.contentSelector)
    parse()
}


function onBeforeContentReplace() {
    // destroy and remove content components
    _.each(_.filter(instances, component => component.scope === 'content'), component => {
        component.$destroy()
        instances = _.without(instances, component)
    })
}


function parse() {
    const componentsEls = document.querySelectorAll(`[${config.componentAttribute}]`)
    _.each(componentsEls, el => {
        const componentName = _.kebabCase(el.getAttribute(config.componentAttribute))
        importComponent(componentName)
            .then(componentObject => {
                // quit if no component is found
                if (!componentObject) {
                    return
                }

                componentObject = _.cloneDeep(componentObject)

                // test if component is global or not
                let scope = 'global'
                let parentEl = el

                while (parentEl && parentEl.parentNode) {
                    if (parentEl === contentEl) {
                        scope = 'content'
                        parentEl = null
                    } else {
                        parentEl = parentEl.parentNode
                    }
                }

                // add store to the vue instance
                componentObject.component.store = store

                // extend data object
                if (_.isPlainObject(componentObject.component.data)) {
                    componentObject.component.data = _.assign(componentObject.component.data, { scope })
                } else {
                    componentObject.component.data = { scope }
                }

                // set data & remove window object
                const componentId = el.getAttribute(config.componentId)
                if (window[`__${componentId}`]) {
                    componentObject.component.data = _.assign(componentObject.component.data, window[`__${componentId}`])
                    delete window[`__${componentId}`]
                }

                // remove data script
                const dataScript = el.parentNode.querySelector(`#data-${componentId}`)
                if (dataScript) {
                    dataScript.parentNode.removeChild(dataScript)
                }

                // set template
                componentObject.component.template = nodeToVueTemplate(el)

                // create component and then mount the element
                const componentInstance = new Vue(componentObject.component)
                componentInstance.$mount(el)

                // remove component attribute / id
                componentInstance.$el.removeAttribute(config.componentAttribute)
                componentInstance.$el.removeAttribute(config.componentId)

                // add the instance to the set
                instances.push(componentInstance)
            })
            .catch(str => console.error(str))
    })
}


function nodeToVueTemplate(el) {
    const elCopy = el.cloneNode(true)
    replaceAttributesToVueTemplate(elCopy)
    return elCopy.outerHTML.replace(/\s\s+/g, ' ')
}


function replaceAttributesToVueTemplate(el) {
    if(el.tagName.toLowerCase() === 'svg') {
        return
    }

    // replace attributes
    if (el.hasAttributes()) {
        const elAttributes = _.map(el.attributes, function (attribute) {
            return {
                name: attribute.name.toLowerCase(),
                value: attribute.value
            }
        })

        for (let i = elAttributes.length - 1; i >= 0; i--) {
            const attrName = elAttributes[i].name
            const attrValue = elAttributes[i].value
            const bindMatch = attrName.match(/^data\-bind\-(.+)$/)
            const onMatch = attrName.match(/^data\-on\-(.+)$/)
            let vueAttributeName = null

            // bind directive
            if (bindMatch && bindMatch[1]) {
                vueAttributeName = `v-bind:${bindMatch[1]}`
            }

            // on directive
            if (onMatch && onMatch[1]) {
                vueAttributeName = `v-on:${onMatch[1]}`
            }

            // other directives
            switch (attrName) {
                case 'data-html':
                    vueAttributeName = 'v-html'
                    break;

                case 'data-text':
                    vueAttributeName = 'v-text'
                    break;

                case 'data-show':
                    vueAttributeName = 'v-show'
                    break;

                case 'data-if':
                    vueAttributeName = 'v-if'
                    break;

                case 'data-else':
                    vueAttributeName = 'v-else'
                    break;

                case 'data-else-if':
                    vueAttributeName = 'v-else-if'
                    break;

                case 'data-for':
                    vueAttributeName = 'v-for'
                    break;

                case 'data-model':
                    vueAttributeName = 'v-model'
                    break;

                case 'data-pre':
                    vueAttributeName = 'v-pre'
                    break;

                case 'data-cloak':
                    vueAttributeName = 'v-cloak'
                    break;

                case 'data-once':
                    vueAttributeName = 'v-once'
                    break;

                case 'data-ref':
                    vueAttributeName = 'ref'
                    break;
            }

            if (vueAttributeName) {
                el.removeAttribute(attrName)
                el.setAttribute(vueAttributeName, attrValue)
            }
        }
    }

    // recursively convert children attributes
    if (el.children.length) {
        for (let i = el.children.length - 1; i >= 0; i--) {
            replaceAttributesToVueTemplate(el.children[i])
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/js/modules/components.js